const Intro = () => {
  return (
      <div className="intro">
        <h1>
          Hi, my name is <span className="identity">Eghosa.</span>
        </h1>
        <h3>(=^_^=) I build websites.</h3>
      </div>
  );
}

export default Intro